const urlParams = new URLSearchParams(window.location.search);

(async () => {
  if (urlParams.get('dev') !== null) {
    await require('~/lib/gui');
  }
  if (false && (process.env.VERCEL || process.env.NETLIFY)) {
    const PasswordScreen = await require('~/dev/PasswordScreen').default;
    let psScreen = new PasswordScreen({
      options: {
        handleSuccess: async () => {
          psScreen.props.state = 'loader';
          const Canvas = await require('~/imog/Canvas').default;
          window.canvas = new Canvas({
            options: {
              handleItemLoaded: (a) => psScreen.itemLoaded(a),
              handleReady: () => {
                if (!psScreen) return;
                psScreen.destroy();
                psScreen = null;
              },
            },
          });
        },
      },
    });
  } else {
    const Canvas = await require('~/imog/Canvas').default;
    window.canvas = new Canvas({
      options: {
        handleReady: () => {},
      },
    });
  }
})();
